import React, { useState, useEffect } from "react";

import SlideMainTitle from "../slides-components/Title";
import SlideWrapper from "../slides-components/SlideWrapper";
import ChoiceButtons from "../slides-components/ChoiceButtons";

const options = ["5%", "15%"];

const SlideImposta = ({ urlParameters, navigate, queryString }) => {
  const [whichActive, setWhichActive] = useState(null);

  useEffect(() => {
    const newQueries = {
      ...urlParameters,
      currentStep: parseInt(urlParameters.currentStep) + 1,
      riduzioneImposte: +!whichActive,
    };

    if (whichActive !== null) {
      navigate("/calcolatore/?" + queryString.stringify(newQueries));
    }
  }, [whichActive, urlParameters, navigate, queryString]);

  return (
    <SlideWrapper>
      <div className="text-center mb-8">
        <SlideMainTitle
          text={"Riduzione delle imposte al 5% per i primi 5 anni?"}
        />
        <div className="flex flex-col justify-center items-center">
          <p className="text-xl text-orange-400 font-bold">Requisiti startup</p>
          <ol className="list-decimal text-left md:w-1/2 rounded-lg bg-orange-100 p-8">
            <li className="pb-2">
              Chi non ha esercitato una attività con partita IVA nei 3 anni
              precedenti l’inizio dell’attività
            </li>
            <li>
              L’attività esercitata non è una prosecuzione di un’altra attività
              svolta come dipendente o lavoratore autonomo (il praticantato
              presso professionisti iscritti all’albo è escluso)
            </li>
          </ol>
        </div>
      </div>
      <ChoiceButtons
        options={options}
        active={whichActive}
        setActive={setWhichActive}
      />
    </SlideWrapper>
  );
};

export default SlideImposta;
